import React, { useState } from "react";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import './SignUpPage.css';
import { useNavigate } from "react-router-dom";

const SignUpPage = () => {
  // State for form fields
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "", // Add confirmPassword field to state
    phoneNumber: "",
    gender: "",
    birthdate: "",
  });

  // State for error message
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // Update form field values
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  // Handle account creation
  const handleCreateAccount = async () => {
    try {
      // Check if the passwords match
      if (formData.password !== formData.confirmPassword) {
        setError("Passwords do not match");
        return;
      }

      // Create the user account
      const authResult = await firebase
        .auth()
        .createUserWithEmailAndPassword(formData.email, formData.password);

      // Access the Firestore database
      const db = firebase.firestore();

      // Create a user document in the 'users' collection with the user's UID
      await db.collection('users').doc(authResult.user.uid).set({
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        gender: formData.gender,
        birthdate: formData.birthdate,
      });

      // Redirect to the dashboard after successful account creation
      navigate("/dashboard");
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="signup-container">
      <h2>Create Account</h2>
      {error && <p className="error-message">{error}</p>}
      <form>
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          id="name"
          value={formData.name}
          onChange={handleInputChange}
        />

        <label htmlFor="email">Email:</label>
        <input
          type="email"
          id="email"
          value={formData.email}
          onChange={handleInputChange}
        />

        <label htmlFor="password">Password:</label>
        <input
          type="password"
          id="password"
          value={formData.password}
          onChange={handleInputChange}
        />

        <label htmlFor="confirmPassword">Confirm Password:</label>
        <input
          type="password"
          id="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleInputChange}
        />

        <label htmlFor="phoneNumber">Phone Number:</label>
        <input
          type="tel"
          id="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleInputChange}
        />

        

        <button type="button" onClick={handleCreateAccount}>
          Create Account
        </button>
      </form>
    </div>
  );
};

export default SignUpPage;
